module.exports = __webpack_public_path__ + "img/hospital11.98501cdb.png";